import * as React from "react";
import MuiListItem from "@material-ui/core/ListItem";

export const ListItem: React.FC = ({ children }) => (
  <MuiListItem>{children}</MuiListItem>
);
